/**
 * Maps internal states to states the brand cares about regarding fulfillment.
 */
export var BrandOrderFulfillmentState;
(function (BrandOrderFulfillmentState) {
    /**
     * The brand has not yet accepted the order.
     */
    BrandOrderFulfillmentState["NEW"] = "NEW";
    /**
     * The brand has accepted the order, but has not added shipments to it.
     */
    BrandOrderFulfillmentState["UNFULFILLED"] = "UNFULFILLED";
    /**
     * The brand has added shipments to the order.
     */
    BrandOrderFulfillmentState["FULFILLED"] = "FULFILLED";
    /**
     * The order is canceled, and the brand was contacted about the order.
     */
    BrandOrderFulfillmentState["CANCELED"] = "CANCELED";
})(BrandOrderFulfillmentState || (BrandOrderFulfillmentState = {}));
